
import React from "react";
import { useTournament } from "@/contexts/TournamentContext";
import { TournamentLeaderboard } from '../shared/TournamentLeaderboard';

export const Leaderboard: React.FC = () => {
  const { tournamentState } = useTournament();
  
  // Convert Mexicano players to the format expected by shared component
  const players = tournamentState.players.map(player => ({
    id: player.id,
    name: player.name,
    points: player.points,
    gamesPlayed: player.matchesPlayed,
    matchesPlayed: player.matchesPlayed,
    roundScores: player.roundScores || [] // Now this property exists
  }));
  
  return (
    <TournamentLeaderboard
      players={players}
      currentRound={tournamentState.currentRound}
      isFinished={!tournamentState.isActive && tournamentState.currentRound > 0}
      tournamentType="mexicano"
    />
  );
};
